import { ColumnsType } from '../../../../core/constants/columnsType';
import { isMobile } from '../../../../core/helpers/isMobile';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { popupStore } from '../../../../store/popupStore';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isSafari } from '../../../../core/constants/browserDetect';
import { soundService } from '../../../../services/baseSoundService/soundService';

export const AUTO_BET_COUNT_PRECISION = 0;
export const MULTIPLIER_PRECISION = 2;
export const WIN_CHANCE_PRECISION = 6;
export const WIN_CHANCE_STEP_VALUE = 1;
export const MULTIPLIER_STEP_VALUE = 1;
export const MULTIPLIER_MAX_LENGTH = 7;
export const WIN_CHANCE_MAX_LENGTH = 8;
export const WIN_CHANCE_MAX_LENGTH1 = 9;
export const AUTO_BET_MAX_LENGTH = 2;

export const DEFAULT_WIN_CHANCE_VALUE = 49;
export const DEFAULT_MULTIPLIER_VALUE = 2;
export const DEFAULT_GAME_RESULT_VALUE = '1.00';

export const MULTIPLIER_LIMIT = {
  minBet: 1.01,
  maxBet: 1000000,
};

export const WIN_CHANCE_LIMIT = {
  minBet: 0.000098,
  maxBet: 97,
};

export const LIMBO_RTP = (isInPG) => (isInPG ? 0.97 : 0.99);

export const LIMBO_GAME_ID = 37;

export const LimboLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.TargetMultiplier,
    dataKey: 'odd',
    isShow: !isMobile(),
    additionalInfoRenderer: () => 'x',
    columnType: ColumnsType.Default,
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'resultOdd',
    isShow: true,
    colRenderer: (spinInfo) => {
      return <span className='cpt-table-text'>{spinInfo.spinData?.resultOdd}x</span>;
    },
    columnType: ColumnsType.Default,
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const LimboBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: isMobile() ? TranslationKeys.Multiplier : TranslationKeys.TargetMultiplier,
    dataKey: 'odd',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'resultOdd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const LimboSoundsName = {
  winNormal: 'win_normal',
  loseNormal: 'lose_normal',
  loseTurbo: 'lose_turbo',
  winTurbo: 'win_turbo',
  bet: 'bet',
  bgMusic: 'bg-music',
  increase: 'increase',
  shortWin: 'short-win',
  longWin: 'long-win',
  shortLose: 'short-lose',
  longLose: 'long-lose',
};

export const LimboSoundsPath = [
  {
    src: 'audio/limbo/bg-music.mp3',
    name: LimboSoundsName.bgMusic,
    autoplay: false,
    html5: true,
    loop: false,
    buffer: true,
    onplay: function () {
      if (isSafari) {
        this._sounds[0]._node.bufferTime = 2; // need it for safari
        this._sounds[0]._node.bufferTimeSet = true;
      }
    },
    onend: function () {
      soundService.play(LimboSoundsName.bgMusic);
    },
  },
  {
    src: 'audio/limbo/bet.mp3',
    name: LimboSoundsName.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/limbo/Win_normal_short.mp3',
    name: LimboSoundsName.shortWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/limbo/Win_normal_long.mp3',
    name: LimboSoundsName.longWin,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/limbo/Lose_normal_long.mp3',
    name: LimboSoundsName.longLose,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/limbo/Lose_normal_short.mp3',
    name: LimboSoundsName.shortLose,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/limbo/win_turbo.mp3',
    name: LimboSoundsName.winTurbo,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/limbo/lose_turbo.mp3',
    name: LimboSoundsName.loseTurbo,
    autoplay: false,
    html5: true,
  },
];

export const LIMBO_RULES_KEYS = new Array(isPG() ? 14 : 11)
  .fill(null)
  .map((item, index) => index + 1);
export const LIMBO_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
